export type ReportMonthOption = {
    label: string;
    value: string;
    periodFrom: Date;
    periodTo: Date;
}

const BG_MONTH_NAMES = [
    "януари",
    "февруари",
    "март",
    "април",
    "май",
    "юни",
    "юли",
    "август",
    "септември",
    "октомври",
    "ноември",
    "декември",
];

function createMonthOption(baseDate: Date): ReportMonthOption {
    const periodFrom = new Date(baseDate.getFullYear(), baseDate.getMonth(), 1);
    const periodTo = new Date(baseDate.getFullYear(), baseDate.getMonth() + 1, 0);

    return {
        label: `${BG_MONTH_NAMES[periodFrom.getMonth()]}, ${periodFrom.getFullYear()}`,
        value: `${periodFrom.getFullYear()}-${String(periodFrom.getMonth() + 1).padStart(2, "0")}`,
        periodFrom,
        periodTo,
    };
}

export function getReportMonthOptions(today: Date): ReportMonthOption[] {
    return Array.from({length: 13}, (_, index) => {
        const optionDate = new Date(today.getFullYear(), today.getMonth() - index, 1);
        return createMonthOption(optionDate);
    });
}
